import React from "react";
import { Box, Tooltip } from "@material-ui/core";
import { get, pick } from "lodash";
import { GRID_STATUS } from "../../../../constants/literalConstant";
import { useStyles } from "../styles";
import {
  targetStatusColor,
  targetStatusTxtColor,
} from "Components/TargetListing/constants";

const UserStatus = (colProps) => {
  const classes = useStyles();
  const status = get(colProps, GRID_STATUS, "");
  const statusColor = pick(targetStatusColor, status);
  const statusTxtColor = pick(targetStatusTxtColor, status);
  return (
    <td>
      <Box display={"flex"} alignItems="center" justifyContent="center">

        <Tooltip title={status}>
          <span
            className={`${classes.statusBg} truncate-txt target-status`}
            style={{
              backgroundColor:
                colProps?.isArchive === true ? "#E7E7E9" : statusColor[status],
              color:
                colProps?.isArchive === true
                  ? "#757B77"
                  : statusTxtColor[status],
            }}
          >
            {status}
          </span>
        </Tooltip>
      </Box>
    </td>
  );
};

export default UserStatus;
